import React from 'react';
import Impostazioni from '../../Schedina/Impostazioni';
import '../../Schedina/Schedina.css';
import {cambioQuota, impostaCambioQuota, predefinitiSchedina, ascolta} from '../../../preferenze';

/**
 * LA ROTELLINA IN TESTATA: la STESSA finestra «Impostazioni» della schedina
 * (cambio quota, formato quote, fuso), non una copia.
 *
 * COSA FA. Disegna la rotellina e la finestra (il componente Impostazioni
 * della schedina), leggendo e scrivendo le scelte nelle preferenze: la
 * spunta del cambio quota e' la stessa che si vede sulla schedina, il
 * formato e il fuso pure. Dove sta la rotellina — sulla schedina, qui, o
 * tutte e due — lo decide il modulo Sport › Schedina: BarraAlta la monta
 * solo con «in testata» o «tutte e due».
 *
 * COSA NON FA. Non legge il profilo di gioco: il predefinito della spunta lo
 * scrive la schedina nelle preferenze quando il profilo arriva; prima di
 * allora la spunta parte spenta, come nella schedina.
 */
export default function RotellinaTestata() {
  const [aperta, setAperta] = React.useState(false);
  const [, ridisegna] = React.useState(0);
  React.useEffect(() => ascolta(() => ridisegna((n) => n + 1)), []);
  const predefiniti = predefinitiSchedina();
  return (
    <span className="testata-rotellina">
      <Impostazioni
        aperta={aperta}
        onApri={setAperta}
        cambioQuota={cambioQuota()}
        onCambioQuota={(v) => impostaCambioQuota(v)}
        includeRiproposta={Boolean(predefiniti.includeRiproposta)}
      />
    </span>
  );
}
